"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.joinPathSegments = void 0;
const PATH_SEGMENT_DIVIDER = '/';

/**
 * Joins path segments and ensures that there are no duplicated double slashes between them
 */
const joinPathSegments = (...pathnames) => pathnames.filter(Boolean).join(PATH_SEGMENT_DIVIDER).replaceAll(/\/+/g, PATH_SEGMENT_DIVIDER)
// Siple preserve of protocols as double slashes were deleted previously
.replace('https:/', 'https://').replace('http:/', 'http://');
exports.joinPathSegments = joinPathSegments;
